import { render, staticRenderFns } from "./ConsumerUnit.vue?vue&type=template&id=0b8a9f04&scoped=true"
import script from "./ConsumerUnit.vue?vue&type=script&lang=js"
export * from "./ConsumerUnit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8a9f04",
  null
  
)

export default component.exports